<template>
    <dashboard-layout>
        <section class="content py-4">
            <div class="card shadow border-0">
                <div class="p-4 border-bottom">
                    <div class="d-flex justify-content-between">
                        <h6 class="mb-0 fw-bold">
                            {{ item?.name }}
                        </h6>
                        <div>
                            <span v-if="! isEnd()">{{ formatTime(timeLeft) }}</span>
                            <span v-else>Session expired</span>
                        </div>
                    </div>
                </div>

                <div class="p-4">
                    <div class="feature-primary key-feature d-flex align-items-center justify-content-between">
                        <div class="d-flex align-items-center">
                            <div class="flex-1">
                                <h6 class="mb-0 text-dark">This mock exam consists of {{ item.questions_count }}
                                    questions</h6>
                                <small class="text-muted"> over {{ item?.duration }} minutes</small>
                            </div>
                        </div>
                    </div>

                    <QuestionComponent :questionsData="questionsData"
                                       :isEnd="isEnd"
                                       :meta="meta"
                                       :result="result"
                                       :session="session"
                                       :type="'mock_exams'"
                                       @fetchQuestions="fetchQuestions"
                                       v-if="questionsData.length > 0"
                                       @update:session="session = $event"
                                       @update:result="result = $event"
                    />
                </div>
            </div>
        </section>
    </dashboard-layout>
</template>

<script>
import {useToast} from "vue-toastification";
import DashboardLayout from "../../dashboard-layout.vue";
import QuestionComponent from "../question_sessions/QuestionComponent.vue";
import axios from "axios";
import RatingButtons from "../share/RatingButtons.vue";

const toast = useToast();

export default {
    components: {RatingButtons, QuestionComponent, DashboardLayout},
    data() {
        return {
            item: [],
            questionsData: [],
            meta: {},
            timeLeft: 0,
            toastId: null,
            intervalId: null,
            checkIntervalId: null,
            result: null,
            session: {
                is_completed: false,
            },
        }
    },
    created() {
        this.fetchQuestions();
        this.startTimer();
    },
    beforeDestroy() {
        this.stopTimer();
    },
    beforeRouteLeave(to, from, next) {
        this.stopTimer();
        next();
        console.log(this.toastId);
        if(this.toastId !== null){
            toast.dismiss(this.toastId);
        }
    },
    methods: {
        isEnd(){
            // return this.questionsData.every(question => question.answer !== null) || this.timeLeft <= 0;
            return  this.timeLeft <= 0  || this.session?.is_completed === true  ;
        },
        fetchQuestions(page = 1) {
            const id = toast.info('Getting content ...', {icon: 'fa-solid fa-download'});
            axios.get(`mock_exams/${this.$route.params.exam_id}`, {
                params: {
                    'page': page,
                    'subscribe_id': this.$route.params?.subscribe_id,
                }
            }).then(response => {
                this.item = response.data.data;
                this.questionsData = response.data.questions.data;
                this.meta = response.data.questions.meta;
                this.timeLeft = response.data.session.duration_seconds; // duration in seconds
                this.session = response.data.session; // duration in seconds
                this.result = response.data.result;

                toast.dismiss(id);
            }).catch(error => {
                toast.dismiss(id);
                toast.error(`Error: ${error.response ? error.response.data.message : 'An error occurred'}`);
            });
        },
        startTimer() {
            this.intervalId = setInterval(() => {
                if (this.timeLeft > 0) {
                    this.timeLeft--;
                } else {
                    this.handleSessionExpiration();
                }
            }, 1000);

            this.checkIntervalId = setInterval(() => {
                this.sendPresenceConfirmation();
            }, 10000);
        },
        stopTimer() {
            if (this.intervalId) {
                clearInterval(this.intervalId);
                this.intervalId = null;
            }
            if (this.checkIntervalId) {
                clearInterval(this.checkIntervalId);
                this.checkIntervalId = null;
            }
        },
        formatTime(seconds) {
            const minutes = Math.floor(seconds / 60);
            const remainingSeconds = seconds % 60;
            return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
        },
        sendPresenceConfirmation() {
            // تأكيد التواجد كل 30 ثانية
            axios.post(`/mock_exams_sessions/confirm_presence`, {
                'exam_id': this.$route.params.exam_id,
                'subscribe_id': this.$route.params?.subscribe_id
            }).then(response => {
                // handle the response if necessary
            }).catch(error => {
                // handle the error if necessary
            });
        },
        handleSessionExpiration() {
            this.stopTimer(); // تأكد من إيقاف التايمرات
            this.toastId = toast.error('Session has expired');
            // setTimeout(function () {
            //     toast.dismiss(id);
            // }, 3000);
            // this.$router.push({name: 'mock_exams.index'});
        }
    }
}
</script>
